import { createColumnHelper } from '@tanstack/react-table';

import { CollectionPoint } from 'types/location';
import { Site } from 'types/site';
import getSiteNameBySiteID from 'utils/getSiteNameBySiteID';

const col = createColumnHelper<CollectionPoint>();

export const buildCollectionPointColumns = (allSites: Site[]) => [
  col.accessor((point) => point?.name || '-', {
    id: 'name',
    header: 'Name',
    minSize: 130,
    size: 160,
  }),
  col.accessor(
    (point) =>
      point?.address?.fullAddress || point?.address?.addressLine1 || '-',
    {
      id: 'address',
      header: 'Address',
      minSize: 280,
      size: 520,
    },
  ),
  col.accessor((point) => point?.type || '-', {
    id: 'type',
    header: 'Type',
    minSize: 100,
  }),
  col.accessor((point) => point?.pickupFrequency || '-', {
    id: 'pickupFrequency',
    header: 'Pickup Frequency',
    minSize: 140,
  }),
  col.accessor((point) => point?.deliveryInstructions || '-', {
    id: 'deliveryInstructions',
    header: 'Instructions',
    minSize: 200,
    size: 320,
  }),
  col.accessor((point) => getSiteNameBySiteID(point?.site, allSites), {
    id: 'site',
    header: 'Linked Site',
    minSize: 130,
    size: 160,
  }),
];
